export const SITE_NAME = "10Adventures"
export const SITE_DOMAIN = "https://www.10adventures.com"

// use these for hard-coded links
export const BASE_PATH_BLOG = "/blog/"
export const BASE_PATH_ROUTE_GUIDES = "/route-guides/"
export const BASE_PATH_TOURS = "/tours/"
export const BASE_PATH_MAP = "/map/"
